module.exports = __webpack_public_path__ + "static/assets/f8f623e87ea477db26923f103147ab27.png";